import type { TreeProps } from './Tree';

export interface OldTreeProps extends Omit<TreeProps, 'onCheckedChange'> {
  /** @deprecated onCheckedChange를 대신 사용해주세요. */
  onChecked?: TreeProps['onCheckedChange'];
}

export function convertOldTreeProps(props: OldTreeProps): TreeProps {
  const { onChecked, ...restProps } = props;

  return {
    ...restProps,
    onCheckedChange: onChecked,
  };
}
